import React, { useContext } from "react";
import "./custombet.css";
import Button from "../../component/Button/Button";
import { GamePopupContext } from "../../component/Context/GamePopupContext";

export const CustomBet = ({ betAmount, shadowText,glow }) => {
  const {
    dispatchPopUp,
    // gameState
  } = useContext(GamePopupContext);
  return (
    <div className="col-lg-2 last-col-challenge">
      <span className={`${glow ? 'animate-glory overflow-hidden animate-span' : ''}`}></span>
      <h6 className="before-text">Challenge Now</h6>
      <div className="last-col-div1">
        <h2>Place Your Own Bet</h2>
      </div>
      <div className="last-col-div2">
        <img src={require("../../Assets/img/cartoon.png")} alt="character" />
        <Button
        className = 'linear-sm-2'
          value="Play Now &#8594;"
          onClick={() => dispatchPopUp({ type: "open", name: "CUSTOM_BET" })}
        />
      </div>
    </div>
  );
};
